import React from 'react';
import type { AutomationTemplate } from '../templates.types';
import { TemplatesTableRow } from './TemplatesTableRow';
import { TemplatesTableEmpty } from './TemplatesTableEmpty';
import styles from './TemplatesTable.module.css';

interface TemplatesTableProps {
  templates: AutomationTemplate[];
  isSyncInProgress: boolean;
}

export const TemplatesTable: React.FC<TemplatesTableProps> = ({
  templates,
  isSyncInProgress,
}) => {
  return (
    <>
      <div className="overflow-x-auto">
        <table className={styles.automationTemplatesTable}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {templates.map((template: AutomationTemplate) => (
              <TemplatesTableRow
                key={template.id}
                template={template}
                isSyncInProgress={isSyncInProgress}
              />
            ))}
          </tbody>
        </table>
      </div>

      {templates.length === 0 && <TemplatesTableEmpty />}
    </>
  );
};
